<template>
  <div>
    <!-- 头部 -->
    <div class="navbar docs-nav2"
         style="position: fixed;top: 0px;left: 0px;width: 100%;z-index: 1002;background: #003d80 !important;">
      <div class="container hiden-title" style="width: 1200px;padding: 0;transition: .3s;max-height:200px" :style="{
        'max-height': gotoTop ? '200px' : '0',
        overflow: gotoTop ? '' : 'hidden'
      }">
        <!-- 产品分类菜单lw2024.1 -->
        <el-collapse-transition>
          <div class="classify-meun" v-show="classifyShow" @mouseleave="classifyShow = false">
            <div class="classify-name" v-if="classifyType === 1">
              <div title="通用IT产品，无行业限制，平台专家团队严格审核入围，厂商不能申请入驻" @click="goClassify(1)"
                   @mouseenter="handleClassifyName(1)"
                   :class="{ isActive: productType === 1 }">
                <i class="fa fa-codepen"></i>
                <span class="classify-title">IT产品严选<span class="fa fa-angle-right"></span></span>
              </div>
              <div title="通用IT产品，无行业限制，厂商自由申请入驻，用户点评排名靠前可转入IT产品严选"
                   @click="goClassify(0)" @mouseenter="handleClassifyName(0)"
                   :class="{ isActive: productType === 0 }">
                <i class="fa fa-cube"></i>
                <span class="classify-title">IT产品普选<span class="fa fa-angle-right"></span></span>
              </div>
            </div>
            <div class="classify-name" v-if="classifyType === 2">
              <div title="特定行业软件，有行业场景限制，平台专家团队严格审核入围，厂商不能申请入驻"
                   @click="goClassifySolution(1)"
                   @mouseenter="handleClassifyNameBySolution(1)" :class="{ isActive: solutionType === 1 }">
                <i class="fa fa-database"></i>
                <span class="classify-title-s">行业软件严选<span class="fa fa-angle-right"></span></span>
              </div>
              <div title="特定行业软件，有行业场景限制，厂商自由申请入驻，用户点评排名靠前可转入行业软件严选"
                   @click="goClassifySolution(0)"
                   @mouseenter="handleClassifyNameBySolution(0)" :class="{ isActive: solutionType === 0 }"><i
                  class="fa fa-diamond"></i><span class="classify-title-s">行业软件普选<span
                  class="fa fa-angle-right"></span></span></div>
            </div>
            <div class="classify-name" v-if="classifyType === 3">
              <div @click="goClassifyCompany()" :class="{ isActive: true }">
                <i class="fa fa-building-o"></i>
                <span class="classify-title-c">IT公司<span class="fa fa-angle-right"></span></span>
              </div>
            </div>
            <div class="one-classify">
              <div @mouseenter="handleOneClassify(item)" class="one-classify-item"
                   v-for="(item, index) in oneClassifyProduct" :key="index">
                <span class="one-classify-title">
                  <span :class="{ isActive: item.isActive }" @click="clickOneClassify(item)">{{ item.dictLabel }}</span>
                  <span :class="{ isActive: item.isActive }" v-if="classifyType === 1 || classifyType === 2">{{
                      item.count
                    }}</span>
                </span>
                <span class="fa fa-angle-right" :class="{ isActive: item.isActive }"></span>
              </div>
            </div>
            <div class="two-classify">
              <div @click="handleTwoClassifyTag(item)" v-for="(item, index) in twoClassifyProduct" :key="index">
                <span class="f14">{{ item.categoryName }}</span>
                <span>{{ item.count }}</span>
              </div>
            </div>
          </div>
        </el-collapse-transition>

        <el-collapse-transition>
          <div class="classify-meun" v-show="drawer" @mouseleave="drawer = false">
            <div class="classify-name" v-if="true">
              <div style="width:100%;padding: 0px;">
                <div v-if="yxArray.length > 0" style="height: 300px;padding: 0px;">
                  <el-card class="box-card" style="height:100%">
                    <div slot="header" class="clearfix">
                      <i class="fa fa-codepen"></i><span class="box-name">{{
                        queryType == 0 ? 'IT产品' : '行业软件'
                      }}严选</span>
                      <div @click="toMore(1)" class="more">更多></div>
                    </div>
                    <el-row :gutter="20">
                      <el-col class="left-item" :span="6" v-for="(item, index) in yxArray" :key="index">
                        <div @click="goInfoPage(item, 1)" class="left-item-top">
                          <div class="item-icon">
                            <el-image :src="item.productImages" fit="contain"
                                      style="width: 102px; height: 67px"></el-image>
                          </div>
                          <div class="item-info">
                            <div class="info-title ellipsis" :title="item.productName">{{ item.productName }}</div>
                            <span class="info-rate">
                              <span class="layui-icon layui-icon-star-fill"></span>
                              <span class="rate-num">{{ (item.totalScore).toFixed(1) }}<span
                                  class="fs12">分</span></span>
                              <span class="grayD fs12" style="margin:0 10px 0 10px">|</span>
                              <span class="gray9 fs12" style="font-weight: 400;">评论 {{ item.commentNumber }}</span>
                            </span>
                            <span class="info-company fs12">
                              <span>
                                <span class="gray6 el-icon-box"></span>
                                <span class="gray6 ellipsis" :title="item.productFactory" style="font-weight: 400;">{{
                                    item.productFactory.length > 5 ? item.productFactory.substr(0, 5) + '...' :
                                        item.productFactory
                                  }}</span>
                              </span>
                              <span class="gray9"><i class="el-icon-view" style="margin-right:2px;"></i>{{
                                  item.hitNum
                                }}</span>
                            </span>
                          </div>
                        </div>
                        <div class="left-item-bottom">
                          <span @click="handleCare(item)" class="el-icon-plus">关注</span>
                          <span>|</span>
                          <span @click="goInfoComment(item, 1)" class="el-icon-edit-outline">点评</span>
                          <span>|</span>
                          <span @click="openContactmodal(item, 1)" class="el-icon-chat-dot-round">咨询</span>
                        </div>
                      </el-col>
                    </el-row>
                  </el-card>
                </div>
                <div v-if="pxArray.length > 0" style="height: 300px;padding: 0px;">
                  <el-card class="box-card" style="height:100%">
                    <div slot="header" class="clearfix">
                      <i class="fa fa-cube"></i><span class="box-name">{{
                        queryType == 0 ? 'IT产品' : '行业软件'
                      }}普选</span>
                      <div @click="toMore(0)" class="more">更多></div>
                    </div>
                    <el-row :gutter="20">
                      <el-col class="left-item" :span="6" v-for="(item, index) in pxArray" :key="index">
                        <div @click="goInfoPage(item, 0)" class="left-item-top">
                          <div class="item-icon">
                            <el-image :src="item.productImages" fit="contain"
                                      style="width: 102px; height: 67px"></el-image>
                          </div>
                          <div class="item-info">
                            <div class="info-title ellipsis" :title="item.productName">{{ item.productName }}</div>
                            <span class="info-rate">
                              <span class="layui-icon layui-icon-star-fill"></span>
                              <span class="rate-num">{{ (item.totalScore).toFixed(1) }}<span
                                  class="fs12">分</span></span>
                              <span class="grayD fs12" style="margin:0 5px;font-size: 16px;">|</span>
                              <span class="gray9 fs12" style="font-weight: 400;">评论 {{ item.commentNumber }}</span>
                            </span>
                            <span class="info-company fs12">
                              <span>
                                <span class="gray6 el-icon-box"></span>
                                <span class="gray6 ellipsis" :title="item.productFactory" style="font-weight: 400;">{{
                                    item.productFactory.length > 5 ? item.productFactory.substr(0, 5) + '...' :
                                        item.productFactory
                                  }}</span>
                              </span>
                              <span class="gray9"><i class="el-icon-view" style="margin-right:2px"></i>{{
                                  item.hitNum
                                }}</span>
                            </span>
                          </div>
                        </div>
                        <div class="left-item-bottom">
                          <span @click="handleCare(item)" class="el-icon-plus">关注</span>
                          <span>|</span>
                          <span @click="goInfoComment(item, 0)" class="el-icon-edit-outline">点评</span>
                          <span>|</span>
                          <span @click="openContactmodal(item, 0)" class="el-icon-chat-dot-round">咨询</span>
                        </div>
                      </el-col>
                    </el-row>
                  </el-card>
                </div>
              </div>
            </div>
            <div class="empty" v-else>
              <el-empty :image-size="200"></el-empty>
            </div>
          </div>
        </el-collapse-transition>

        <!-- 设为首页、收藏本站 class="setIndex"-->
        <div style="margin-top: 8px;display: flex;justify-content:space-between;">
          <div style="width: 20%;">
            <div style="margin-left: 34px;color:white;font-size:12px">
              <span style="cursor: pointer;" @click="setHomePage">设为首页&nbsp;&nbsp;</span>
              <span style="cursor: pointer;" @click="addFavorit">收藏本站</span>
            </div>
            <div style="margin-top: 8px;">
              <a href="/index">
                <img alt="qidao123.com:企服评测·应用市场·商务社交-IT产业互联网"
                     src="https://images.qidao123.com/static/newLogo202507.jpg" style="height: 50px;"/>
              </a>
            </div>
          </div>

          <form style="width: 50%;margin-top: auto;" @submit.prevent>
            <div v-if="!seachShow" class="input-group input-groups head-search">
              <div class="input-group-btn" style="width: 5%;">
                <button style="border-radius: 0;color: #fff;" type="button" id="btnType" :class="chooseClass"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ showName }} <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" id="ulType">
                  <li>
                    <el-tooltip effect="light" content="通用IT产品，无行业限制；" placement="right">
                      <a @click="saveBg" href="/product-classify?type=1">IT产品</a>
                    </el-tooltip>
                  </li>
                  <li>
                    <el-tooltip effect="light" content="非通用IT产品，特定行业应用；" placement="right">
                      <a @click="saveBg" href="/solution-classify?type=1">行业软件</a>
                    </el-tooltip>
                  </li>
                  <li><a @click="saveBg" href="/company-classify">IT公司</a></li>
                  <li><a @click="saveBg" href="/expert">专家</a></li>
                  <li><a @click="saveBg" href="/case-list">案例</a></li>
                </ul>
              </div>
              <input @keyup.enter="query_Data1()" @change="changeSearch" id="txtQuery" type="text" class="form-control"
                     title="人脉/IT产品/行业软件/IT公司/商机/项目/资料/专家，就上qidao123.com"
                     placeholder="人脉/IT产品/行业软件/IT公司/商机/项目/资料/专家,就上qidao123.com"/>
              <span class="input-group-btn">
                <button class="btn" type="button" v-on:click="query_Data1()"
                        style="background: #ea5413; color: #fff; width: 100%;margin-left: 0;border-radius: 0;">
                  搜索
                </button>
              </span>
            </div>
          </form>


          <div v-if="showLogin" class="myrelation" style="width: 27%;">
            <div :class="authdata.data.identityType == 0 ? 'myloginmword' : 'myloginword'">
              <span class="myword" style="margin-right: 20px;">real people</span>
              <span class="myword">real review</span><br/>
            </div>
            <div class="user in-top navbar-right hidden-xs" style="display: flex;">
              <span @click="changeshow()"><i class="el-icon-search mywhite"
                                             style="margin-right: 20px;cursor:pointer;line-height: 40px;"></i></span>
              <img v-if="authdata.data.avatar == ''"
                   :class="[authdata.data.isOnline == 1 ? 'userheadBorder' : 'userhead']"
                   src="http://images.qidao123.com/static/user.png" alt=""/><img v-else
                                                                                 :class="[authdata.data.isOnline == 1 ? 'userheadBorder' : 'userhead']"
                                                                                 :src="authdata.data.avatar"
                                                                                 alt=""/>
              <span class="username">
                <a style="color: white;line-height: 40px;" href="javascript:void(0);" @click="go('/myproduct')">
                  {{ realName }}
                </a>
              </span>

              <span style="line-height: 37px;">
                <span v-if="authdata.data.usertype == 1 && authdata.data.identityType != 0" class="pro-b">乙</span>
                <span v-if="authdata.data.usertype == 0 && authdata.data.identityType != 0" class="pro-c">甲</span>
                <span v-else-if="authdata.data.identityType == 2" class="pro-b">企</span>
                <span v-if="authdata.data.identityType == 3 && authdata.data.identityType != 0">
                  <span class="pro-c">三</span>
                  <span class="pro-c">方</span>
                </span>
                <span v-if="authdata.data.identityType == 0" class="pro-c">管</span>
              </span>

              <div style="line-height: 40px;display: inline-block; cursor: pointer;"
                   :class="messageCount > 0 ? 'animImageActive' : 'animImage'">
                <a style="color: #ffffff" :class="active[9]" href="/mymessage">消息</a>
                <el-badge v-if="messageCount > 0" class="mark-top" :value="messageCount" :max="99"/>
              </div>
              <span style="line-height: 40px;margin-left: 12px;">
                <span data-uid="1" @click="user_loginout()"><a href="javascript:void(0);"
                                                               class="mywhite">退出</a> </span>
                <span v-if="authdata.data.identityType == 0" class="docs-logout" style="margin-left: 2px;height: 24px;">
                  <a href="http://admin.qidao123.com/#/login?redirect=%2Findex"
                     style="text-decoration: none;color: #007ddb;">后台</a>
                </span>
              </span>

              <span style="position: absolute; top: 76px; right: -15px" class="freeEnter login-btn"
                    @mouseenter="showEnter = true">&nbsp;免费入驻&nbsp;
                <div style="top:33px;" class="showEnter" v-show="showEnter" @mouseleave="showEnter = false">
                  <div @click="go_to(1)" style="">
                    IT产品入驻
                  </div>
                  <div @click="go_to(2)" style="margin-top:5px">
                    行业软件入驻
                  </div>
                  <div @click="go_to(3)" style="margin-top:5px">
                    IT公司入驻
                  </div>
                  <div @click="go_to(4)" style="margin-top:5px">
                    案例入驻
                  </div>
                </div>
              </span>
            </div>
          </div>

          <!-- <div v-if="!showLogin" class="btn-group hidden-xs" role="group" aria-label="..."
            style="margin-top:44px;margin-right: 0;"> lw2025.5.21 该margin-top:44px影响head高度，和登录的head统一为33px-->
          <div v-if="!showLogin" class="btn-group hidden-xs" role="group" aria-label="..."
               style="margin-top:33px;margin-right: 0;">
            <div class="myunloingword">
              <span class="myword" style="margin-right: 10px;">real people</span>
              <span class="myword">real review</span>
              <br/>
            </div>
            <div
                style="width:265px;padding-left: 62px;margin-top: 8px;display: flex;flex-direction: row-reverse;align-items: center;">
              <span class="freeEnter login-btn" @mouseenter="showEnter = true">&nbsp;免费入驻&nbsp;
                <div class="showEnter" v-show="showEnter" @mouseleave="showEnter = false">
                  <div @click="go_to(1)" style="">
                    IT产品入驻
                  </div>
                  <div @click="go_to(2)" style="margin-top:5px">
                    行业软件入驻
                  </div>
                  <div @click="go_to(3)" style="margin-top:5px">
                    IT公司入驻
                  </div>
                  <div @click="go_to(4)" style="margin-top:5px">
                    案例入驻
                  </div>
                </div>
              </span>
              <span class="separate"></span>
              <span class="loginAndRegister login-btn">
                <!-- <span type="button" data-toggle="modal" data-target="#loginModal">&nbsp;登录
                </span> -->
                <span type="button" @click="showLoginModal">&nbsp;登录
                </span>
                <span>·</span>
                <span type="button" @click.stop="toRegister2">注册&nbsp;</span>
              </span>
              <a style="margin-right: 5px;"><i @click="changeshow()" style="cursor:pointer;"
                                               class="el-icon-search mywhite"></i></a>
            </div>
          </div>
        </div>
      </div>

      <!-- 菜单栏 -->
      <div class="container" style="margin-top: 9px;width: 1200px;padding-left: 0px;">
        <nav id="navbar" class="navbar-collapse collapse" style="padding-left: 0px;">
          <ul class="nav navbar-nav" style="margin-top: -8px; background-color: #003d80;font-weight: 500;width: 1200px;"
              ref="nav">
            <li :class="active[0]">
              <a href="javascript:void(0);" @click="go('/index')" onclick="" class="nav-li-pd fs16">
                首页
              </a>
            </li>
            <li :class="active[1]">
              <a href="javascript:void(0);" @click="select(1)" class="nav-li-pd flex">
                <div class="f16">找IT产品</div>
                <i :class="elarrow2" style="font-size: 10px;margin-left:3px"/>
              </a>
            </li>
            <li :class="active[2]">
              <a href="javascript:void(0);" @click="select(2)" class="nav-li-pd flex">
                <div class="f16">找行业软件</div>
                <i :class="elarrow3" style="font-size: 10px;margin-left:3px"/>
              </a>
            </li>
            <li :class="active[3]">
              <a href="javascript:void(0);" @click="select(3)" class="nav-li-pd fs16">
                找IT公司
              </a>
            </li>
            <li :class="active[13]">
              <a href="javascript:void(0);" @click="go('/case-list')" onclick="" class="nav-li-pd fs16">
                找案例
              </a>
            </li>
            <li :class="active[4]">
              <a href="javascript:void(0);" @click="go('/right-person')" onclick="" class="nav-li-pd fs16">
                找人脉
              </a>
            </li>
            <li :class="active[5]">
              <a href="javascript:void(0);" @click="go('/expert')" onclick="" class="nav-li-pd fs16">
                专家智库
              </a>
            </li>
            <li :class="active[7]">
              <a href="javascript:void(0);" @click="go('/reward')" onclick="" class="nav-li-pd fs16">
                招标悬赏
              </a>
            </li>
            <li :class="active[8]">
              <a href="https://dis.qidao123.com/group.php" onclick="" class="nav-li-pd fs16">
                ToB圈子
              </a>
            </li>
            <li :class="active[12]">
              <a href="javascript:void(0);" @click="go_saas()" class="nav-li-pd flex">
                <div class="f16">SAAS软件</div>
                <i :class="elarrow4" style="font-size: 10px;margin-left:3px"/>
              </a>
              <ul v-show="saasShow" @mouseleave="leave_sass()"
                  style="color: black; position: absolute; z-index: 9999;border-radius: 2px;">
                <li id="saas-li">
                  <a href="javascript:void(0);" @click="go_auth('/saas-product?type=1')">IT产品严选</a>
                </li>
                <li id="saas-li">
                  <a href="javascript:void(0);" @click="go_auth('/saas-product?type=0')">IT产品普选</a>
                </li>
                <li id="saas-li">
                  <a href="javascript:void(0);" @click="go_auth('/saas-solution?type=1')">行业软件严选</a>
                </li>
                <li id="saas-li">
                  <a href="javascript:void(0);" @click="go_auth('/saas-solution?type=0')">行业软件普选</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!--密码登录框-->
    <div class="modal fade bs-example-modal-lg" id="loginModal" tabindex="-1" role="dialog"
         aria-labelledby="myModalLabel" style="top:12%">
      <div class="modal-dialog" role="document" style="width:800px">
        <div class="modal-content">
          <button type="button" class="close login-close" data-dismiss="modal" aria-label="Close">
            <span @click="login = true" aria-hidden="true">&times;</span>
          </button>
          <!-- 登录模块 -->
          <div v-if="login" class="row login-panel login-body">
            <div>
              <img src="http://images.qidao123.com/static/newAddpic.gif" alt="" style="width:375px;border-radius: 7px;">
              <div class="login-foot-top">
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/static/footImg/foot1.png" alt="">
                  <span class="mt5">微信订阅号</span>
                </div>
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/static/footImg/foot2.png" alt="">
                  <span class="mt5">微信服务号</span>
                </div>
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/static/footImg/foot3.png" alt="">
                  <span class="mt5">微信客服(加群)</span>
                </div>
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/images/h5qr.jpg" alt=""
                       style="width:78px;height:78px;margin-top: -8px;margin-left: -6px;">
                  <span class="">H5</span>
                </div>
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/images/xcxqr.png" alt=""
                       style="width:70px;height:70px;margin-top: -5px;margin-left: -8px;">
                  <span class="" style="margin-top:3px">小程序</span>
                </div>
              </div>
            </div>
            <div class="row login-text">
              <div class="col-xs-10 col-xs-offset-1">
                <ul class="nav nav-pills in-section" style="margin: 0">
                  <li role="presentation" class="active">
                    <a href="#normalLogin" role="tab" data-toggle="tab">密码登录</a>
                  </li>
                  <li role="presentation">
                    <a href="#phoneLogin" role="tab" data-toggle="tab">快捷登录</a>
                  </li>
                </ul>
                <div class="tab-content login-tab-content">
                  <div role="tabpanel" class="tab-pane" id="phoneLogin">
                    <form class="form-horizontal">
                      <div class="form-group">
                        <label class="sr-only" for="exampleInputPhone">手机号码</label>
                        <vue-country-intl :onlyValue="true" style="width: 110px;position: absolute;height: 50px;"
                                          v-model="countryCode"></vue-country-intl>
                        <input
                            style="border-radius: 0 4px 4px 0;width: calc(100% - 100px);position: relative;left: 100px;"
                            @blur="userPhoneLogin(1)" v-model="userPhone" type="tell" class="form-control"
                            id="exampleInputPhone" placeholder="请输入手机号码"/>
                        <!-- <input
                          @blur="userPhoneLogin(1)" v-model="userPhone" type="tell" class="form-control"
                          id="exampleInputPhone" placeholder="请输入手机号码" /> -->
                        <div v-show="userPhoneLoginError" style="margin-top: 10px; color: #eb5412;"
                             class="el-icon-warning">用户不存在，请先去注册
                        </div>
                        <span id="helpBlock2" class="sr-only text-danger">请输入正确格式的手机号码</span>
                      </div>
                      <div class="form-group">
                        <label class="sr-only" for="exampleInputyzm">验证码</label>
                        <div class="input-group">
                          <input type="password" class="form-control" id="exampleInputyzm" placeholder="请输入验证码"/>
                          <span class="input-group-btn">
                            <button type="button" style="height: 44px; font-size: 15px" id="btnSendSms"
                                    class="btn btn-primary btn-lg btn-block" @click="sendSmsData()">
                              发送验证码
                            </button>
                          </span>
                        </div>
                      </div>
                      <button type="button" class="btn btn-primary btn-lg btn-block"
                              onclick="username_and_yzm_login();">
                        立即登录
                      </button>
                      <div class="goregister">
                        <a href="javascript:void(0)" @click.stop="login = false" style="color: #333333;">忘记密码</a>
                        <span style="color: #e9e9e9e9;font-size: 15px;"> | </span>
                        <span style="color: #333333;">没有账号？</span>
                        <a href="javascript:void(0)" @click.stop="toRegister2">去注册</a>
                      </div>
                      <div class="weixinlogin">
                        <div>或使用以下账号直接登录(需已注册)</div>
                        <div @click="wetChatLogin"><img style="width: 48px"
                                                        src="http://images.qidao123.com/static/weixin.jpg"/></div>
                      </div>
                    </form>
                  </div>
                  <div role="tabpanel" class="tab-pane active" id="normalLogin">
                    <form class="form-horizontal">
                      <div class="form-group">
                        <label class="sr-only" for="exampleInputUserName">用户名</label>
                        <input @blur="userPhoneLogin(2)" v-model="userName" type="text" class="form-control"
                               id="exampleInputUserName" placeholder="请输入用户名"/>
                        <div v-show="userPwdLoginError" style="margin-top: 10px; color: #eb5412;"
                             class="el-icon-warning">
                          该号码未注册，<a href="javascript:void(0)" @click.stop="toRegister2" style="color: #eb5412;">请先注册</a>
                        </div>
                        <span id="helpBlock2" class="sr-only text-danger">请输入正确格式的用户名</span>
                      </div>
                      <div class="form-group">
                        <label class="sr-only" for="exampleInputPassword">密 码</label>
                        <input type="password" class="form-control" id="exampleInputPassword" placeholder="请输入密码"/>
                        <span id="helpBlock2" class="sr-only text-danger">用户名和密码不匹配</span>
                      </div>
                      <button type="button" class="btn btn-primary btn-lg btn-block"
                              onclick="username_and_password_login();">
                        立即登录
                      </button>
                      <div class="goregister">
                        <a href="javascript:void(0)" @click.stop="login = false" style="color: #333333;">忘记密码</a>
                        <span style="color: #e9e9e9e9;font-size: 15px;"> | </span>
                        <span style="color: #333333;">没有账号？</span>
                        <a href="javascript:void(0)" @click.stop="toRegister2">去注册</a></div>
                      <div class="weixinlogin">
                        <div>或使用以下账号直接登录(需已注册)</div>
                        <div @click="wetChatLogin"><img style="width: 48px"
                                                        src="http://images.qidao123.com/static/weixin.jpg"/></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 忘记密码 -->
          <div v-if="!login" class="row login-panel login-body">
            <div>
              <img src="http://images.qidao123.com/static/newAddpic.gif" alt="" style="width:355px;border-radius: 5px;">
              <div class="login-foot-top" style="margin-top:100px">
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/static/footImg/foot1.png" alt="">
                  <span class="mt5">微信订阅号</span>
                </div>
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/static/footImg/foot2.png" alt="">
                  <span class="mt5">微信服务号</span>
                </div>
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/static/footImg/foot3.png" alt="">
                  <span class="mt5">微信客服</span>
                </div>
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/images/h5qr.jpg" alt=""
                       style="width:78px;height:78px;margin-top: -8px;margin-left: -6px;">
                  <span class="">H5</span>
                </div>
                <div class="login-foot-top-item">
                  <img src="http://images.qidao123.com/images/xcxqr.png" alt=""
                       style="width:70px;height:70px;margin-top: -5px;margin-left: -8px;">
                  <span class="" style="margin-top:3px">小程序</span>
                </div>
              </div>
            </div>
            <div class="row login-text" style="padding: 0px 0 40px 0;">
              <div class="col-xs-10 col-xs-offset-1">
                <div class="tab-content login-tab-content">
                  <div class="active">
                    <form class="form-horizontal">
                      <div class="findPwd">找回密码</div>
                      <div class="form-group">
                        <label class="sr-only" for="exampleInputPhone">手机号码</label>

                        <vue-country-intl :onlyValue="true" style="width: 110px;position: absolute;height: 50px;"
                                          v-model="countryCode"></vue-country-intl>
                        <input
                            style="border-radius: 0 4px 4px 0;width: calc(100% - 100px);position: relative;left: 100px;"
                            @input="checkPhone" v-model="phone" type="tell" class="form-control"
                            id="exampleInputPhone" placeholder="请输入手机号码"/>
                        <i v-if="!phoneSign && phone != ''"
                           style="position: relative;top: -30px;left: 95%;color: #67C23A;" class="fa fa-check-circle"
                           aria-hidden="true"></i>
                        <span v-if="phoneSign && phone != ''" class="text-danger">*请输入正确格式的手机号码</span>
                        <span v-if="phone == ''" class="text-danger">*请输入手机号码</span>
                      </div>
                      <div class="form-group">
                        <label class="sr-only" for="exampleInputPhone">新密码</label>
                        <input v-model="password" @input="checkPwd" type="password" class="form-control"
                               id="exampleInputPhone"
                               placeholder="新密码，必须包含字母、数字和特殊字符 3 种及以上，长度至少为 8 位"/>
                        <i v-if="!pwdSign && password != ''"
                           style="position: relative;top: -30px;left: 95%;color: #67C23A;" class="fa fa-check-circle"
                           aria-hidden="true"></i>
                        <span v-if="pwdSign && password != ''" class="text-danger">*请输入正确格式的密码</span>
                        <span v-if="password == ''" class="text-danger">*请输入密码</span>
                      </div>
                      <div class="form-group">
                        <label class="sr-only" for="exampleInputyzm">验证码</label>
                        <div class="input-group">
                          <input v-model="code" @input="checkNumber" type="password" class="form-control"
                                 id="exampleInputyzm" placeholder="短信验证码"/>
                          <i v-if="!codeSign && code != ''"
                             style="position: absolute;top: 15px;left: 74%;color: #67C23A;z-index: 10;"
                             class="fa fa-check-circle" aria-hidden="true"></i>
                          <span v-if="codeSign && code != ''" style="position: absolute;top: 50px;left: 0;"
                                class="text-danger">*请输入正确格式的短信验证码</span>
                          <span v-if="code == ''" style="position: absolute;top: 50px;left: 0;"
                                class="text-danger">*请输入短信验证码</span>
                          <span class="input-group-btn">
                            <button type="button" style="height: 44px; font-size: 15px;" id="btnSendSms"
                                    class="btn btn-primary btn-lg btn-block" @click="checkAndSend">
                              发送验证码
                            </button>
                          </span>
                        </div>
                      </div>
                      <button :disabled="pwdSign || phoneSign || codeSign" style="margin-top: 30px;" type="button"
                              class="btn btn-primary btn-lg btn-block" @click="sendForget">
                        确定修改
                      </button>
                      <div class="goregister"><a href="javascript:void(0)" @click.stop="login = true">返回登录</a><span
                          style="color: black;font-size: 16px;"> | </span><a href="javascript:void(0)"
                                                                             @click.stop="toRegister2">快速注册</a>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 微信扫码登录 -->
    <div class="modal fade bs-example-modal-lg" id="weinCode" tabindex="-1" role="dialog"
         aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close login-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="row login-panel">
            <div class="row login-text">
              <div class="col-xs-10 col-xs-offset-3">

                <iframe style="height: 400px;text-align: center;" :src="qrUrl" scrolling="no" frameborder="0"
                        class="trend-container2"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 提示弹框  lw2024.2.2-->
    <el-dialog :visible.sync="enterModelShow" width="716px" @close="closeEnterDialog">
      <div slot="title">
        <div class="enterDialog-title">
          <el-image class="icon" src="http://images.qidao123.com/static/titleIcon.png"></el-image>
          <span>{{ typeName }}</span>
          <el-image class="icon" src="http://images.qidao123.com/static/titleIcon.png"></el-image>
        </div>
        <div style="font-size:14px;color:#666666;text-align: center;margin-top:8px">
          入驻完成后，信息将显示在数字名片中，方便传播裂变
        </div>
      </div>
      <div class="enterDialog-conten">
        <div class="enterDialog-item">
          <el-image class="icon" src="http://images.qidao123.com/static/chanping.png"></el-image>
          <div class="enterDialog-info">
            <span>IT产品入驻</span>
            <span>如果贵公司有自主IT产品，且是不分行业的通用IT产品</span>
          </div>
          <div class="enterDialog-btn" @click="go_streight(1)">立即入驻</div>
        </div>
        <div class="enterDialog-item">
          <el-image class="icon" src="http://images.qidao123.com/static/fangan.png"></el-image>
          <div class="enterDialog-info">
            <span>行业软件入驻</span>
            <span>如果贵公司有自主产权行业软件，且是具体行业特定行业软件</span>
          </div>
          <div class="enterDialog-btn" @click="go_streight(2)">立即入驻</div>
        </div>
        <div class="enterDialog-item">
          <el-image class="icon" src="http://images.qidao123.com/static/gongsi.png"></el-image>
          <div class="enterDialog-info">
            <span>IT公司入驻</span>
            <span>如果贵公司无自主产权产品，是渠道/代理/服务等IT生态企业</span>
          </div>
          <div class="enterDialog-btn" @click="go_streight(3)">立即入驻</div>
        </div>
      </div>
      <!-- <div align="center" style="margin-top: 20px;">
        <span style="color: #606266; line-height: 19px; font-size: 13px">{{ countDown1 }} 秒后自动跳转到申请流程</span>
      </div> -->
    </el-dialog>
    <contact-model></contact-model>
  </div>
</template>
<script>
import HeadMenu from "./head-menu"
import ContactModel from "../../components/ContactModel"
import {forGetPassword} from "../../api/qdw/userinfo.js"

import VueCountryIntl from 'vue-country-intl';
import 'vue-country-intl/lib/vue-country-intl.css'

export default {
  name: 'vue-nav',
  components: {HeadMenu, ContactModel, VueCountryIntl},
  data() {
    return {
      countryCode: '86',
      chooseClass: 'btn dropdown-toggle bnc',
      seachShow: false,
      yxArray: [],//严选展示数组
      pxArray: [],//普选展示数组
      drawer: false,
      direction: 'ttb',
      enterModelShow: false,
      userPhone: '',
      userName: '',
      isuserExist: false,
      login: true,
      queryType: 0,//0 产品 1：公司 2：论坛 3:解决方案  4：专家
      showName: 'IT产品',
      showLogin: false,
      active: [],
      authdata: {
        data: {
          avatar: '',
          realName: '',
        }
      },
      realName: '',
      itemshow: false,
      saasShow: false,
      elarrow: 'el-icon-arrow-down',
      show_search: '',
      messageCount: 0,
      itemshow2: false,
      elarrow2: 'el-icon-arrow-down',
      itemshow3: false,
      elarrow3: 'el-icon-arrow-down',
      elarrow4: 'el-icon-arrow-down',
      showEnter: false,
      countDown1: 30,
      typeName: '',
      inval1: "",
      qrUrl: "",

      //2024-1-12 czh,忘记密码
      phoneSign: true,
      pwdSign: true,
      codeSign: true,
      phone: '',
      password: '',
      code: '',
      // lw2024.1.23
      productType: 1,//1是严选，0是普选
      oneClassifyProduct: [],//产品/方案一级分类
      twoClassifyProduct: [],//产品/方案二级分类
      solutionType: 1,//1是严选，0是普选
      classifyShow: false,
      classifyType: 0,//分类菜单类型，1是产品，2是方案，3是公司
      classifyCompany: [],//公司分类数据
      userPhoneLoginError: false,
      userPwdLoginError: false,
      lastScrollTop: 0,//上次滚动的位置
      gotoTop: true,//向上滚动
    }
  },
  props: ['num', 'show'],
  created() {
    this.active[this.num] = 'active'
    this.show_search = this.show
  },
  methods: {
    saveBg() {
      localStorage.setItem('bg', 1);
    },
    //change时间监听search的变化
    changeSearch(e) {
      localStorage.setItem('search', e.target.value)
    },

    //发送验证码
    sendSmsData() {
      //this.countryCode
      sendSms('exampleInputPhone', 'btnSendSms', this.countryCode);
    },

    //发送短信校验
    checkAndSend() {
      if (this.phoneSign) {
        layer.msg('手机号格式不正确', {icon: 6});
      } else if (this.pwdSign) {
        layer.msg('新密码，必须包含字母、数字和特殊字符 3 种及以上，长度至少为 8 位', {icon: 6});
      } else {
        sendSms('exampleInputPhone', 'btnSendSms', this.countryCode);
      }
    },
    //跳转到产品或者方案列表页面
    toMore(type) {
      let search = $('#txtQuery').val()
      if (this.queryType == 0) {
        // this.$router.push(`/product-classify?type=${type == 0 ? 0 : 1}&search=${search}`)
        this.$router.push(`/product-classify?type=${type == 0 ? 0 : 1}&search=${encodeURIComponent(search)}`)
      } else if (this.queryType == 3) {
        // this.$router.push(`/solution-classify?type=${type == 0 ? 0 : 1}&search=${search}`)
        this.$router.push(`/solution-classify?type=${type == 0 ? 0 : 1}&search=${encodeURIComponent(search)}`)
      }
    },
    //跳转到详情页的评论区
    goInfoComment(item, type) {
      if (this.queryType == 0) {
        this.$router.push(`/${type == 1 ? 'product-info2' : 'product-info3'}?productId=${item.productId}`)
      } else if (this.queryType == 3) {
        this.$router.push(`${type == 1 ? 'solution-info2' : 'solution-info3'}?solutionId=${item.solutionId}`)
      }
      $('html,body').animate({scrollTop: '800px'})
    },
    //打开咨询
    openContactmodal(item, flag) {
      let contactname = "";
      let url = "";
      if (this.queryType == 0) {
        contactname = item.productMainTypeName + "|" + item.categoryName + "|" + item.productName
        url = flag == 1 ? "/product-info2?productId=" : "/product-info3?productId="
        $("#h4_contacttitle").html("<span class='myblue'>" + "①信息不会泄露&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp" + "②无过度打扰&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp" + "③无广告营销" + "</span>")
        $("#inputproductid").val(item.productId)
        $("#inputcontactmenu").val(contactname)
        $("#inputcontacturl").val(url + item.productId)
        $('#contactModal').modal("show")
      } else if (this.queryType == 3) {
        contactname = item.solutionMainTypeName + "|" + item.categoryName + "|" + item.productName
        url = flag == 1 ? "/solution-info2?solutionId=" : "/solution-info3?solutionId="
        $("#h4_contacttitle").html("<span class='myblue'>" + "①信息不会泄露&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp" + "②无过度打扰&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp" + "③无广告营销" + "</span>")
        $("#inputproductid").val(item.solutionId)
        $("#inputcontactmenu").val(contactname)
        $("#inputcontacturl").val(url + item.solutionId)
        $('#contactModal').modal("show")
      }
    },
    //产品关注
    handleCare(item) {
      let userId = JSON.parse(localStorage.getItem('authdata')).data.userId

      if (userId) {
        if (this.queryType == 0) {
          this.$post(`/product/care/${item.productId}/${userId}`).then(res => {
            if (res.code == 200) {
              layer.alert('关注成功！', {icon: 6})
              item.careNum += 1
            } else {
              layer.alert('关注失败！', {icon: 6})
            }
          })
        } else if (this.queryType == 3) {
          this.$post(`/solution/care/${item.solutionId}/${userId}`).then(res => {
            if (res.code == 200) {
              layer.alert('关注成功！', {icon: 6})
              item.careNum += 1
            } else {
              layer.alert('关注失败！', {icon: 6})
            }
          })
        }

      } else {
        layer.alert('用户未登陆，请<a class="mydarkred" href="/register">注册</a>并登录', {icon: 6})
      }

    },
    //跳转到产品详情页
    goInfoPage(item, type) {
      if (this.queryType == 0) {
        this.$router.push(`/${type == 1 ? 'product-info2' : 'product-info3'}?productId=${item.productId}`)
      } else if (this.queryType == 3) {
        this.$router.push(`${type == 1 ? 'solution-info2' : 'solution-info3'}?solutionId=${item.solutionId}`)
      }
    },
    handleClose() {
      this.drawer = false
    },
    clickOneClassify(item) {
      if (this.classifyType === 1) {
        this.goClassify(this.productType, item.dictValue)
      } else if (this.classifyType === 2) {
        this.goClassifySolution(this.solutionType, item.dictValue)
      } else {
        this.goClassifyCompany()
      }
    },
    goClassify(type, mainId = '', categoryId = '') {
      if (this.$route.path == '/product-classify') {
        if (mainId == '' && categoryId == '') {
          this.$router.push(`/product-classify?type=${type}`).catch(err => err)
        } else {
          this.$router.push(`/product-classify?type=${type}&productMainTypeId=${mainId}&productCategoryId=${categoryId}`).catch(err => err)
        }
      } else {
        if (mainId == '' && categoryId == '') {
          this.$router.push(`/product-classify?type=${type}`)
        } else {
          this.$router.push(`/product-classify?type=${type}&productMainTypeId=${mainId}&productCategoryId=${categoryId}`)
        }
      }
    },
    goClassifySolution(type, mainId = '', categoryId = '') {
      if (this.$route.path == '/solution-classify') {
        if (mainId == '' && categoryId == '') {
          this.$router.push(`/solution-classify?type=${type}`).catch(err => err)
        } else {
          this.$router.push(`/solution-classify?type=${type}&solutionMainTypeId=${mainId}&solutionCategoryId=${categoryId}`).catch(err => err)
        }
      } else {
        if (mainId == '' && categoryId == '') {
          this.$router.push(`/solution-classify?type=${type}`)
        } else {
          this.$router.push(`/solution-classify?type=${type}&solutionMainTypeId=${mainId}&solutionCategoryId=${categoryId}`)
        }
      }
    },
    goClassifyCompany(areaId = '', categoryId = '', categorySecondId = '') {
      if (this.$route.path == '/company-classify') {
        if (areaId == '' && categoryId == '' && categorySecondId == '') {
          this.$router.push(`/company-classify`).catch(err => err)
        } else {
          this.$router.push(`/company-classify?areaId=${areaId}&categoryId=${categoryId}&categorySecondId=${categorySecondId}`).catch(err => err)
        }
      } else {
        if (areaId == '' && categoryId == '' && categorySecondId == '') {
          this.$router.push(`/company-classify`).catch(err => err)
        } else {
          this.$router.push(`/company-classify?areaId=${areaId}&categoryId=${categoryId}&categorySecondId=${categorySecondId}`).catch(err => err)
        }
      }
    },
    handleTwoClassifyTag(item) {
      if (this.classifyType === 1) {
        this.goClassify(this.productType, item.productMainTypeId, item.productCategoryId)
      } else if (this.classifyType === 2) {
        this.goClassifySolution(this.solutionType, item.solutionMainTypeId, item.solutionCategoryId)
      } else if (this.classifyType === 3) {
        let categoryId = ''
        let categorySecondId = ''
        let areaId = ''
        if (item.dictType === 'company_category') {
          categoryId = item.dictValue
        } else if (item.dictType === 'company_grading') {
          categorySecondId = item.dictValue
        } else {
          areaId = item.areaId
        }
        this.goClassifyCompany(areaId, categoryId, categorySecondId)
      }
    },
    select(type) {
      this.classifyShow = true
      this.classifyType = type
      if (this.classifyShow && type === 1) {
        this.getProductOneClassify(1)
        this.getProductTwoClassify('1001')
      } else if (this.classifyShow && type === 2) {
        this.getSolutionOneClassify(1)
        this.getSolutionTwoClassify('1030')
      } else if (this.classifyShow && type === 3) {
        this.getCompanyClassify()
      }
    },
    handleClassifyName(type) {
      this.productType = type
      this.getProductOneClassify(type)
      this.getProductTwoClassify('1001')
    },
    handleClassifyNameBySolution(type) {
      this.solutionType = type
      this.getSolutionOneClassify(type)
      this.getSolutionTwoClassify('1030')
    },
    getProductOneClassify(type) {
      let that = this
      $.ajax({
        url: serverUrl + `/basics/productmaintype/${type}/null`,
        type: "get",
        async: true,
        success: function (data) {
          if (data.code == 200) {
            for (const ele of data.data) {
              ele.isActive = false
            }
            data.data[0].isActive = true
            that.oneClassifyProduct = data.data
          }
        }
      })
    },
    getProductTwoClassify(productMainTypeId) {
      this.twoClassifyProduct = []
      let that = this
      let productType = this.productType
      $.ajax({
        url: serverUrl + `/product/categoryandtag/all?productMainTypeId=${productMainTypeId}&createFlag=${productType}`,
        type: "get",
        async: true,
        success: function (data) {
          if (data.code == 200) {
            that.twoClassifyProduct = data.data
          }
        }
      })
    },
    getSolutionOneClassify(type) {
      let that = this
      $.ajax({
        url: serverUrl + `/basics/solutionmaintype/${type}/null`,
        type: "get",
        async: true,
        success: function (data) {
          if (data.code == 200) {
            for (const ele of data.data) {
              ele.isActive = false
            }
            data.data[0].isActive = true
            that.oneClassifyProduct = data.data
          }
        }
      })
    },
    getSolutionTwoClassify(solutionMainTypeId) {
      this.twoClassifyProduct = []
      let that = this
      let solutionType = this.solutionType
      $.ajax({
        url: serverUrl + `/solution/categoryandtag/all?solutionMainTypeId=${solutionMainTypeId}&createFlag=${solutionType}`,
        type: "get",
        async: true,
        success: function (data) {
          if (data.code == 200) {
            that.twoClassifyProduct = data.data
          }
        }
      })
    },
    getCompanyClassify() {
      this.oneClassifyProduct = [
        {dictLabel: '公司主营', isActive: true},
        {dictLabel: '业务行业', isActive: false},
        {dictLabel: '所在区域', isActive: false},
      ]
      this.twoClassifyProduct = []
      let that = this
      $.ajax({
        url: serverUrl + `/basics/companytype`,
        type: "get",
        async: true,
        success: function (data) {
          if (data.code == 200) {
            that.classifyCompany = data.data
            for (const ele of that.classifyCompany.category) {
              ele.categoryName = ele.dictLabel
            }
            that.twoClassifyProduct = that.classifyCompany.category
          }
        }
      })
    },
    handleOneClassify(item) {
      for (const ele of this.oneClassifyProduct) {
        ele.isActive = false
      }
      item.isActive = true
      if (this.classifyType === 1) {
        this.getProductTwoClassify(item.dictValue)
      } else if (this.classifyType === 2) {
        this.getSolutionTwoClassify(item.dictValue)
      } else if (this.classifyType === 3) {
        if (item.dictLabel == '公司主营') {
          for (const ele of this.classifyCompany.category) {
            ele.categoryName = ele.dictLabel
          }
          this.twoClassifyProduct = this.classifyCompany.category
        } else if (item.dictLabel == '业务行业') {
          for (const ele of this.classifyCompany.grading) {
            ele.categoryName = ele.dictLabel
          }
          this.twoClassifyProduct = this.classifyCompany.grading
        } else if (item.dictLabel == '所在区域') {
          for (const ele of this.classifyCompany.regionlist) {
            ele.categoryName = ele.areaName
          }
          this.twoClassifyProduct = this.classifyCompany.regionlist
        }
      }
    },
    userPhoneLogin(flag) {
      let userPhone = flag === 1 ? this.userPhone : this.userName
      let _this = this
      $.ajax({
        url: serverUrl + `/userdata/checkPhone?phone=${userPhone}`,
        type: "get",
        async: true,
        contentType: "application/json",
        success: function (data) {
          if (data.code == 200) {
            if (!data.data) {
              if (flag == 1) {
                _this.userPhoneLoginError = true
              } else {
                _this.userPwdLoginError = true
              }
            } else {
              if (flag == 1) {
                _this.userPhoneLoginError = false
              } else {
                _this.userPwdLoginError = false
              }
            }
          }
        }
      })
    },
    sendForget() {
      forGetPassword(this.phone, this.password, this.code)
    },
    //数据校验
    checkPhone(detail) {
      const reg = /^1[3456789]\d{9}$/;//手机号校验
      if (!reg.test(detail.target.value)) {
        this.phoneSign = true
      } else {
        this.phoneSign = false
      }
    },
    checkPwd(detail) {
      // const reg = /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d))|(?=.*[a-zA-Z])(?=.*[\W_])(?=.*\d){8,}$/;//密码校验
      const reg = /^(?:(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])|(?=.*[a-zA-Z])(?=.*\d)(?=.*[,.;:])|(?=.*[a-zA-Z])(?=.*[!@#$%^&*])(?=.*[,.;:])|(?=.*\d)(?=.*[!@#$%^&*])(?=.*[,.;:]))[a-zA-Z\d!@#$%^&*,.;:]{8,30}$/;
      if (!reg.test(detail.target.value) || detail.target.value.length < 8) {
        this.pwdSign = true
      } else {
        this.pwdSign = false
      }
    },
    checkNumber(detail) {
      const reg = /^\d{4}$/;//数字校验
      if (!reg.test(detail.target.value) || detail.target.value.length < 4) {
        this.codeSign = true
      } else {
        this.codeSign = false
      }
    },

    wetChatLogin() {

      $("#loginModal").modal("hide");

      $.ajax({
        url: serverUrl + "/wechat/qrcode/login/wechat_login",
        type: "get",
        dataType: "json",
        contentType: "application/json",
        async: true,
        success: (data) => {
          this.qrUrl = data.data;
          $("#weinCode").modal("show");
        }
      });


    },
    domenu() {
      $("#head_menu").css("margin-top", "300px;")
    },
    changeshow() {
      this.seachShow = !this.seachShow
    },
    aa() {
      $("#loginModal").modal('hide')
    },
    query_Data1() {
      if (!localStorage.getItem("authdata")) {
        $("#loginModal").modal("show");
        return
      }
      let search = $('#txtQuery').val()
      // if ($('#txtQuery').val().length > 0) {
      //   search = encodeUnicode($('#txtQuery').val())
      // } else {
      //   search =
      // }
      localStorage.setItem('search', $('#txtQuery').val())

      let newUrl = ""
      if (this.queryType == 0) {
        this.getList('/product/list')
      } else if (this.queryType == 1) {
        this.$router.push(`/company-classify?search=${encodeURIComponent(search)}`)
      } else if (this.queryType == 2) {
        this.$message.error("暂无页面！")
      } else if (this.queryType == 3) {
        this.getList('/solution/list')
      } else if (this.queryType == 4) {
        newUrl = "/expert"
        window.open(newUrl)
      } else if (this.queryType == 5) {
        newUrl = "/case-list"
        window.open(newUrl)
      }
    },

    getList(url) {//获取产品列表
      let pxflag = true;
      let yxflag = true;
      let data = {
        search: this.search ? this.search : $('#txtQuery').val(),
        productType: 0,
      }
      this.$post(url, {limit: 4, page: 1, ...data}).then(res => {
        if (res.code == 200 && res.data.length > 0) {
          this.yxArray = res.data
        } else {
          this.yxArray = []
          yxflag = false
        }
      })
      data.productType = 2
      this.$post(url, {limit: 4, page: 1, ...data}).then(res => {
        if (res.code == 200 && res.data.length > 0) {
          this.pxArray = res.data
        } else {
          this.pxArray = []
          pxflag = false
        }
      })
      setTimeout(() => {
        if (!pxflag && !yxflag) {
          layer.msg('抱歉，您想找的数据不存在，我们会加油的！', {icon: 5})
          this.drawer = false;
        } else {
          this.drawer = true;
        }
      }, 500)
    },

    user_loginout() {
      let header = {}
      let that = this
      //后台退出
      $.ajax({
        url: serverUrl + "/loginOut",
        type: "get",
        async: true,
        headers: (header = {
          username: localStorage.getItem("username"),
          Authorization: "Api_Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
        }),
        success: function (data) {
          that.$message.success('退出成功！')
          localStorage.clear()
          if (that.$route.path === "/") {
            // 刷新
            location.reload()
          } else {
            that.$router.push("/")
          }
        }
      })
    },
    go(path) {
      $('#txtQuery').val("")
      localStorage.setItem('search', "")
      this.$router.push(path)
    },

    go_streight(type) {
      $("#registerlogin2").modal("hide")
      clearInterval(this.inval1)
      localStorage.setItem("type", type) //存入type防止刷新重置
      if (this.$router.currentRoute.name === 'LocateApply') {
        this.$router.go(0)
      } else {
        this.$router.push({name: "LocateApply"})
      }
    },

    go_to(type) {
      this.enterModelShow = true
      var that = this
      localStorage.setItem("type", type) //存入type防止刷新重置
      // 公司导航申请入驻
      if (type == 3 || type == 2 || type == 1 || type == 4) {
        if (type == 4) {
          this.typeName = "请先申请入驻，完成入驻资料编辑，即可发布案例"
        }
        if (type == 3) {
          this.typeName = "IT公司入驻"
        }
        if (type == 2) {
          this.typeName = "行业软件入驻"
        }
        if (type == 1) {
          this.typeName = "IT产品入驻"
        }
      }
    },
    closeEnterDialog() {
      clearInterval(this.inval1)
    },
    closeModal() {
      $("#registerlogin2").modal("hide")
      clearInterval(this.inval1)
      if (this.$router.currentRoute.name === 'LocateApply') {
        this.$router.go(0)
      } else {
        this.$router.push({name: "LocateApply"})
      }
    },
    go_sub() {
      this.itemshow = !this.itemshow
      if (this.elarrow != "el-icon-arrow-up") {
        this.elarrow = "el-icon-arrow-up"
      } else {
        this.elarrow = "el-icon-arrow-down\n"
      }
    },
    go_saas() {
      this.saasShow = !this.saasShow
      if (this.elarrow4 != "el-icon-arrow-up") {
        this.elarrow4 = "el-icon-arrow-up"
      } else {
        this.elarrow4 = "el-icon-arrow-down\n"
      }
    },
    go_sub_product() {
      this.itemshow2 = !this.itemshow2
      if (this.elarrow2 != "el-icon-arrow-up") {
        this.elarrow2 = "el-icon-arrow-up"
      } else {
        this.elarrow2 = "el-icon-arrow-down\n"
      }
    },
    go_sub_solution() {
      this.itemshow3 = !this.itemshow3
      if (this.elarrow3 != "el-icon-arrow-up") {
        this.elarrow3 = "el-icon-arrow-up"
      } else {
        this.elarrow3 = "el-icon-arrow-down\n"
      }
    },
    go_auth(path) {
      if (this.showLogin) {
        this.$router.push(path)
      } else {
        var index = layer.alert("用户未登录,请<a class='mydarkred' href='/register'>注册</a>并<a class='mydarkred' href='javascript:void(0);'  onclick='openmodal()'>登录</a>!", {icon: 6});
        this.index = index
      }
    },
    layclose() {
    },
    leave_sub() {
      this.itemshow = !this.itemshow
      if (this.elarrow != "el-icon-arrow-up") {
        this.elarrow = "el-icon-arrow-up"
      } else {
        this.elarrow = "el-icon-arrow-down\n"
      }
    },
    leave_sass() {
      this.saasShow = !this.saasShow
      if (this.elarrow4 != "el-icon-arrow-up") {
        this.elarrow4 = "el-icon-arrow-up"
      } else {
        this.elarrow4 = "el-icon-arrow-down\n"
      }
    },
    leave_sub2() {
      this.itemshow2 = !this.itemshow2
      if (this.elarrow2 != "el-icon-arrow-up") {
        this.elarrow2 = "el-icon-arrow-up"
      } else {
        this.elarrow2 = "el-icon-arrow-down\n"
      }
    },
    leave_sub_solution() {
      this.itemshow3 = !this.itemshow3
      if (this.elarrow3 != "el-icon-arrow-up") {
        this.elarrow3 = "el-icon-arrow-up"
      } else {
        this.elarrow3 = "el-icon-arrow-down\n"
      }
    },
    get_user_info() {
      let username = localStorage.getItem("username")
      let token = localStorage.getItem("token")
      let that = this
      if (username != null && token != null) {
        this.showLogin = true
        localStorage.setItem("showLogin", 1)
        let header = {}
        $.ajax({
          url: serverUrl + "/userinfo",
          type: "get",
          async: true,
          headers: (header = {
            username: username,
            Authorization: "Api_Bearer " + token,
            //'connection':'keep-alive',
            "Content-Type": "application/json",
          }),
          success: function (data) {
            if (data.code == 200) {
              //localStorage.setItem("authdata",data);
              that.authdata = data
              localStorage.setItem("authdata", JSON.stringify(data))
              that.realName = data.data.realName
              //todo userHidePhone

              that.$get(that.$api.getMessageNoReadCount_api + "/" + that.getAuthData().userId, {}).then(response => {
                that.messageCount = response.data
              })
            } else {
              localStorage.setItem("showLogin", 0)
              that.showLogin = false
            }
          }

        })
      } else {
        localStorage.setItem("showLogin", 0)
        that.showLogin = false
      }

    },
    // 设为首页
    setHomePage() {
      try {
        this.style.behavior = "url(#default#homepage)"
        this.setHomePage(window.location)
      } catch (e) {
        if (window.netscape) {
          try {
            netscape.security.PrivilegeManager.enablePrivilege(
                "UniversalXPConnect"
            )
          } catch (e) {
            layer.alert("此操作被浏览器拒绝！\n请在浏览器地址栏输入“about:config”并回车\n然后将 [signed.applets.codebase_principal_support]的值设置为'true',双击即可。")
          }
          var prefs = Components.classes[
              "@mozilla.org/preferences-service;1"
              ].getService(Components.interfaces.nsIPrefBranch)
          prefs.setCharPref("browser.startup.homepage", window.location)
        } else {
          layer.alert("您的浏览器不支持，请按照下面步骤操作：1.打开浏览器设置。2.点击设置网页。3.输入：" + window.location + "点击确定。")
        }
      }
    },
    // 加入收藏
    addFavorit() {
      try {
        window.external.addFavorite(window.location, document.title)
      } catch (e) {
        try {
          window.sidebar.addPanel(document.title, window.location, "")
        } catch (e) {
          layer.alert("加入收藏失败，请使用Ctrl+D进行添加")
        }
      }
    },
    // 从登录框跳转到注册页面
    fromModalToRegister() {
      $("#loginModal").modal("hide")
      window.location = "/register"
    },
    // 跳转到注册页面
    toRegister2() {
      this.aa()
      this.login = true
      window.location = "/register"
    },
    handleScroll(e) {
      let st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0; // 获取当前滚动位置  
      if (st > this.lastScrollTop) {
        this.gotoTop = false
      } else {
        this.gotoTop = true
      }

      // 更新上一次滚动位置  
      this.lastScrollTop = st;
    },
    showLoginModal() {
      $("#loginModal").modal("show");
    }
  },
  mounted: function () {
    if (localStorage.getItem('bg') == 1) {
      this.chooseClass = 'btn dropdown-toggle bgc'
      localStorage.setItem('bg', 0)
    } else {
      this.chooseClass = 'btn dropdown-toggle bnc'
    }

    if (this.$route.path === '/') {
      this.seachShow = true;
    } else {
      this.seachShow = false;
    }

    //如果搜索框没有值获取缓存中的搜索值
    if (!$('#txtQuery').val()) {
      $('#txtQuery').val(localStorage.getItem('search'));
    }
    this.get_user_info()
    if (this.num == "2") {
      this.queryType = 3
      this.showName = '行业软件'
    } else if (this.num == "3") {
      this.queryType = 1
      this.showName = 'IT公司'
    } else if (this.num == "5") {
      this.queryType = 4
      this.showName = '专家'
    } else if (this.num == "6") {
      this.queryType = 2
      this.showName = '论坛'
    } else if (this.num == '13') {
      this.queryType = 5
      this.showName = '案例'
    } else {
      this.queryType = 0
      this.showName = 'IT产品'
    }
    let bbs = this.$route.query.bbs
    //从bbs跳转到找靠谱产品
    if (bbs) {
      //免费入驻
      if ([6, 7, 8, 9].includes(bbs * 1)) {
        //6:产品入驻 7:解决方案入驻 8:公司入驻 9:案例入驻
        this.go_to({6: 1, 7: 2, 8: 3, 9: 4}[bbs])
      } else {
        setTimeout(() => {
          bbs !== 'saas' ? this.select(bbs * 1) : this.go_saas()
        }, 3000)
      }

    }
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style>
.animImage {
  font-size: 14px;
  margin-left: 20px;
  color: #ffffff;
}

.animImageActive {
  font-size: 14px;
  margin-left: 13px;
  color: #ffffff;
  -webkit-animation-name: imageAnim;
  -webkit-animation-duration: 1s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-direction: alternate;
  -webkit-animation-timing-function: ease;
  -webkit-animation-play-state: running;
}

@-webkit-keyframes imageAnim {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.mark-top {
  margin-left: -7px;
  margin-top: -5px;
}
</style>
<style lang="scss" scoped>
.isActive {
  color: #eb5412 !important;
}

.input-groups {
  border: 3px solid #eb5412;
  border-radius: 4px;
}

.classify-meun {
  position: absolute;
  top: 132px;
  left: 50%;
  transform: translateX(-50%);
  width: 1201px;
  background-color: #FFFFFF;
  z-index: 999;
  display: flex;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.classify-meun:hover {
  cursor: pointer;
}

.classify-name {
  flex: 1;
  background-color: #ffffff;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
}

.classify-name div {
  font-size: 15px;
  padding: 10px;
}

.classify-name > div > i {
  margin-right: 10px;
}

.classify-name > div:hover .classify-title {
  border-bottom: 2px solid #eb5412;
}

.classify-name > div:hover .classify-title-s {
  border-bottom: 2px solid #eb5412;
}

.classify-name > div:hover .classify-title-c {
  border-bottom: 2px solid #eb5412;
}

.classify-title {
  position: relative;
}

.classify-title > span {
  position: absolute;
  top: 1px;
  right: -60px;
}

.classify-title-s {
  position: relative;
}

.classify-title-s > span {
  position: absolute;
  top: 1px;
  right: -45px;
}

.classify-title-c {
  position: relative;
}

.classify-title-c > span {
  position: absolute;
  top: 1px;
  right: -75px;
}

.one-classify {
  flex: 1;
  height: 570px;
  background-color: #f5f5f5;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  padding-top: 10px;
}

.one-classify > div {
  padding: 10px 16px 5px 30px;
}

.one-classify-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

// .one-classify-item:hover .one-classify-title span:nth-child(1) {
//   border-bottom: 2px solid #eb5412;
// }
.one-classify-item:hover .one-classify-title:nth-child(1) {
  border-bottom: 2px solid #eb5412;
}

.one-classify > div > span:nth-child(1) {
  font-size: 14px;
  color: #232f3e;
}

.one-classify-title > span:nth-child(2) {
  margin-left: 5px;
  font-size: 12px;
  color: #999999;
}

.one-classify-title {
  display: flex;
  align-items: center;
}

.one-classify-title > span {
  line-height: 1;
  font-size: 14px;
  color: #232f3e;
  margin-bottom: 4px;
}

.two-classify {
  flex: 3;
  height: 570px;
  background-color: #ffffff;
  overflow: scroll;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.empty {
  flex: 3;
  height: 465px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.two-classify > div {
  width: 230px;
  height: 35px;
  padding: 10px 0 5px 30px;
  display: flex;
  align-items: center;
}

.two-classify > div:hover {
  color: #eb5412;
}

// .two-classify>div:hover span:nth-child(1) {
//   border-bottom: 2px solid #eb5412;
// }
.two-classify > div:hover :nth-child(1) {
  border-bottom: 2px solid #eb5412;
}

.two-classify > div:hover span:nth-child(2) {
  color: #eb5412;
}

.two-classify > div > span:nth-child(2) {
  margin-left: 5px;
  font-size: 12px;
  color: #999999;
}

.setIndex {
  color: #fff;
  position: absolute;
  z-index: 999;
  font-size: 12px;
  top: 7px;
  left: 64px;
  cursor: pointer;
}

.loginAndRegister {
  background-color: #eb5412;
  color: #fff;
  cursor: pointer;
  padding: 2px;
  border-radius: 2px;
}

.loginAndRegister :nth-child(1):hover,
.loginAndRegister :nth-child(2):hover {
  color: #222f3e;
}

.freeEnter {
  position: relative;
  background-color: #eb5412;
  color: #fff;
  cursor: pointer;
  padding: 2px;
  border-radius: 2px;
}

.showEnter {
  background: #FFF;
  color: #232F3E;
  font-weight: 500;
  font-size: 13px;
  width: 100px;
  padding: 10px 10px;
  position: absolute;
  top: 32px;
  left: 0;
  border-radius: 2px;
  z-index: 999;
}

.showEnter :nth-child(1):hover,
.showEnter :nth-child(2):hover,
.showEnter :nth-child(3):hover,
.showEnter :nth-child(4):hover {
  color: #eb5412;
  text-decoration: underline
}

.goregister {
  padding-top: 20px;
  font-size: 15px;
  text-align: center;
  color: #eb5412;
}

.goregister > a {
  color: #eb5412;
}

.weixinlogin div {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
}

.findPwd {
  text-align: center;
  font-size: 20px;
  margin-bottom: 20px;
}

> > > .el-dialog {
  border-radius: 10px;
}

> > > .el-dialog__body {
  padding: 5px 20px 15px;
}

> > > .el-drawer__container {
  left: 20%;
  top: 9%;
  width: 60%;
}

> > > .el-drawer {
  border-radius: 5px;
  height: 50% !important;
}

.box-name {
  color: #eb5412 !important;
  font-size: 15px;
  padding: 10px
}

> > > .el-card__header {
  padding: 0;
}

.left-item {
  width: 24%;
  height: 143px;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #eee;
  margin: 0 9px 9px 0;
  cursor: pointer;

  &:hover {
    border: 1px solid #0262f1;
  }

  cursor: pointer;
}


.left-item-top {
  width: 100%;
  padding: 21px 10px 20px 21px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-bottom: 1px solid #eee;
}

.item-icon {
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 105px;
  height: 70px;
  border-radius: 5px;
  border: 1px solid #eee;
}

.item-info {
  padding: 0 10px !important;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.info-title {
  padding: 0 !important;
  font-size: 18px !important;
  font-weight: 500;
  color: #232f3e;
  width: 140px;
  margin-top: -3px;
  height: 25px;
}

.info-title:hover {
  color: #eb5412;
}

.info-rate {
  display: flex;
  align-items: center;
  color: #eb5412;
  margin-top: 6px;

  & > :first-child {
    display: inline-block;
    width: 18px;
    height: 18px;
    background-color: #FF702D;
    color: #ffffff;
    line-height: 18px;
    text-align: center;
    border-radius: 3px;
    font-size: 14px;
    padding-bottom: 1px;
  }
}

.rate-num {
  display: inline-block;
  width: 45px;
  font-weight: 500;
  margin-left: 5px;
}

.info-company {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding-right: 20px;
  font-weight: normal;

  & > :first-child {
    display: flex;
    align-items: center;

    & > :nth-child(2) {
      display: inline-block;
      width: 70px;
    }
  }
}

.left-item-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 !important;
  color: #eb5412;
  font-size: 14px;
  font-weight: 400;

  & > :nth-child(odd) {
    width: 68px;
    text-align: center;
  }

  & > :nth-child(2n+2) {
    color: #DDDDDD;
  }
}

.more {
  float: right;
  padding: 0 5px;
  font-size: 14px;
  color: #232f3e;
  opacity: 0.5;
}

.grayD {
  color: #DDDDDD;
}

.gray9 {
  color: #999999;
}

.gray6 {
  color: #666666;
}

.fs12 {
  font-size: 12px;
}

.nav-li-pd {
  padding: 15px 25px !important;
  font-weight: 500 !important;
}

.nav-li-pd:hover {
  background-color: #eb5412 !important;
  color: #ffffff !important;
  font-size: 16px !important;
}

.head-search .dropdown-menu {
  padding: 0;
  min-width: 62px;

  & > li {
    border-bottom: 1px solid #e9e9e9;

    & > a {
      padding: 3px 17px;
    }
  }
}

.dropdown-menu > li > a {
  line-height: 26px !important;
}

.login-btn {
  background: transparent !important;
  border: 1px solid #eb5412;
  color: #fff;
  padding: 5px;
  border-radius: 5px;

  & + .login-btn {
    margin-left: 5px;
    padding: 7px !important;

  }

  span:hover {
    color: #fff !important;
  }
}

.separate {
  background: #fff;
  width: 1px;
  display: inline-block;
  height: 20px;
  margin: 0 5px;
}

.f16 {
  font-size: 16px;
  font-weight: 500;
}

.flex {
  display: flex;
  align-items: center;
}

.f14 {
  font-size: 14px;
}

.login-body {
  display: flex;

  & > :first-child {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 61px;
    margin-left: 40px;

    .login-foot-top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      margin-top: 100px;

      .login-foot-top-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .login-foot-top-item > img {
        width: 65px;
        height: 65px;
      }

      // .login-foot-top-item>span{
      //     font-size: 10px;
      //   }
    }
  }

  & > :nth-child(2) {
    flex: 3;
  }
}

.qidao-logo {
  /* 移除默认的h1样式 */
  margin: 0;
  padding: 0;
  /* 设置Logo的显示方式 */
  display: inline-block;
  /* 可以添加更多的样式，如字体大小、颜色等 */
}

.caret {
  color: #eb5412 !important;
}
</style>
